import React from "react"
import PropTypes from "prop-types"

import Alerts from "emmapi/js/alerts"
import {Redux} from "js_utils"

import FormController from "budde_utils/js/components/forms/FormController"
import {Heading} from "core/js/components/presentation/atoms/heading"
import {BaseText as Text}  from "core/js/components/presentation/atoms/text/base"
import {Link} from "core/js/components/presentation/atoms/link"
import {BaseButton as Button} from "core/js/components/presentation/atoms/button/base"
import {BaseInput as Input} from "core/js/components/presentation/molecules/input/base"
import {EmailInput} from "core/js/components/presentation/molecules/input/email"
import {PasswordInput} from "core/js/components/presentation/molecules/input/password"
import {BaseForm as Form} from "core/js/components/presentation/organisms/form/base"
import {FormBaseItem as FormItem} from "core/js/components/presentation/organisms/form/_item/base"
import {LOGIN_FORM_STORE_KEY, publish_screen, publish_login_form} from "./publishers"


const {get_store} = Redux

const clear_inputs = () => {
    const state = get_store().getState()
    const {[LOGIN_FORM_STORE_KEY]: {fields}} = state
    publish_login_form({fields: dict(
        Object.entries(fields)
        .map(([name, data]) => [name, {...data, value: null}])
    )})
}


class LoginForm extends React.PureComponent {
    static propTypes = {
        url: PropTypes.func.isRequired,
        session_expired: PropTypes.bool.isRequired,
    }

    show_password_reset = event => {
        publish_screen({resetting_password: true})
    }

    render() {
        const {url, session_expired} = this.props
        return <React.Fragment>
                <Heading two semantic
                    style={{marginBottom: "1.5rem"}}
                    color="white"
                >
                    {gettext("Welcome to the world of your songs.")}
                </Heading>
                {
                    session_expired
                    ? <Text color="light">
                        {gettext("For security reasons, you must log in once in a while.")}
                    </Text>
                    : null
                }
                <FormController
                    endpoint={url("authentication:function-login-api")}
                    subscribe_to={LOGIN_FORM_STORE_KEY}
                    publish_to={LOGIN_FORM_STORE_KEY}
                    key="login"
                    config={{
                        init_component: (props) => (null),
                        // credentials: "include",

                        form: {
                            component: (props) => (
                                <Form {...props}
                                    submit_button = {
                                        <React.Fragment>
                                            <Button primary pill disabled={props.is_fetching}
                                                input="submit"
                                                text={gettext("Login")}
                                                style={{
                                                    marginTop: "1rem",
                                                    marginBottom: "0.5rem",
                                                    marginRight: "0.5rem",
                                                    width: "12rem",
                                                }}
                                            />
                                            <Button pill disabled={props.is_fetching}
                                                color="dark"
                                                text={gettext("Forgot password?")}
                                                style={{
                                                    marginTop: "1rem",
                                                    marginBottom: "0.5rem",
                                                    marginLeft: "0.5rem",
                                                    width: "12rem",
                                                }}
                                                onClick={this.show_password_reset}
                                            />
                                        </React.Fragment>
                                    }
                                />
                            ),
                            on_success: () => {window.location = request.script_name || "/"},
                            on_error: (errors, form_controller) => {
                                const fields = {...form_controller.props.fields}
                                for (const field of Object.values(fields)) {
                                    field.errors = null
                                }
                                for (const [field_name, error_list] of Object.entries(errors)) {
                                    if (field_name in fields) {
                                        fields[field_name].errors = error_list
                                    }
                                }
                                form_controller.publish({fields})
                                if ("non_field_errors" in errors) {
                                    for (let error of errors["non_field_errors"]) {
                                        Alerts.Actions.add_alert(
                                            error,
                                            {vanishing: true, type: "negative"}
                                        )
                                    }
                                } else {
                                    if (errors && Object.keys(errors).length) {
                                        Alerts.Actions.add_alert(
                                            gettext("Almost done! Please fix the errors in the highlighted fields."),
                                            {vanishing: true, type: "negative"}
                                        )
                                    }
                                }
                            },
                        },

                        widgets: {
                            component: FormItem,
                            type_widgets: {
                                string: {},
                                nested_form: {},
                                nested_form_set: {},
                            },
                            field_widgets: {
                                email: {
                                    component: (props) => <FormItem {...props}
                                                             label={gettext("Your Email")}
                                                        />,
                                },
                                password: {
                                    component: (props) => <FormItem
                                        {...props}
                                        label={gettext("Your Password")}
                                    />,
                                },
                            },
                        },

                        inputs: {
                            get_options: (options) => options,
                            component: Input,
                            type_inputs: {
                                string: {
                                    component: (props) => <Input
                                        {...props}
                                        type="text"
                                        color="white"
                                    />,
                                },
                            },
                            field_inputs: {
                                email: {
                                    component: props => <EmailInput
                                        {...props}
                                        placeholder={gettext("name@example.de")}
                                        color="white"
                                    />,

                                },
                                password: {
                                    component: props => <PasswordInput
                                        {...props}
                                        color="white"
                                    />,
                                },
                            },
                        },
                    }}
                />
        </React.Fragment>
    }
}


export {LoginForm}
export default LoginForm
